const initialState = {};

/**
 * importPartsDataReducer: Reducer to handle actions related to import data.
 *
 * @param {any} state - The current state of the import part data.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */
const importPartsDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_IMPORT_PART_DATA":
      return action?.payload;
    default:
      return state;
  }
};

export default importPartsDataReducer;

